var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckPricing = function SvgIconCheckPricing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 9.5,
    r: 5.5,
    fill: "#00BA00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D4FFD4",
    fillRule: "evenodd",
    d: "M10.004 1.255a8.751 8.751 0 0 1 0 17.5 8.751 8.751 0 0 1 0-17.5M8.186 12.847l-2.142-2.144a.94.94 0 0 1 0-1.326.94.94 0 0 1 1.326 0l1.51 1.512 3.757-3.757a.94.94 0 0 1 1.326 0 .94.94 0 0 1 0 1.325l-4.421 4.421a.94.94 0 0 1-1.356-.031",
    clipRule: "evenodd"
  })));
};
export default SvgIconCheckPricing;